import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangePasswordVerifyOtp = gql`
  mutation ChangePasswordVerifyOtp($input: ChangePasswordVerifyOtpInput!) {
    changePasswordVerifyOtp(input: $input) {
      ... on ChangePasswordVerifyOtpSuccess {
        code
        __typename
      }

      ... on ChangePasswordIncorrectOtp {
        ...error
        __typename
      }

      ... on ChangePasswordTooManyOtpAttempts {
        ...error
        __typename
      }
      ... on ChangePasswordExpiredOtp {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default ChangePasswordVerifyOtp;
